<template>
  <vk-dialog
    :visible.sync="visible"
    @close="closeDialog"
    :title="vs.agmName + ' ' + vs.agmEng"
    class="agreement-dialog-component"
  >
    <div
      v-loading="loading"
      class="agreement-dialog-content"
      v-html="vs.agmContent.replace(/\$\$studentId/ig, studentId).replace(/\$\$number/ig, '').replace(/\$\$paymentSubject/ig, vs.paymentSubjectName)"
    ></div>
  </vk-dialog>
</template>

<script>

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    version: {
      type: Object,
      default: () => {
        return {}
      }
    },
    versionType: {
      type: String,
      default: ''
    },
    studentId: {
      type: [String, Number],
      default: ''
    },
    serialNumber: {
      type: [String, Number],
      default: ''
    }
  },
  watch: {
    visible: function (val) {
      val ? this.getVersionContent() : this.vs = { ... this.copyVs }
    }
  },
  data() {
    return {
      vs: {
        agmContent: '',
        agmEng: '',
        agmName: '',
        agmVersion: ''
      },
      loading: false,
    }
  },
  created() {
    this.copyVs = { ...this.vs }
  },
  methods: {
    getVersionContent() {
      this.loading = true
      let params = {}
      this.version.versionType === 'payment' ? params.amgId = this.version.id : params.version = this.version.version
      params.serialNumber = this.serialNumber
      this.axios({
        method: 'get',
        url: '/gw/order-rest/api/order_rest/agreement/view/content',
        params
      }).then(res => {
        if (res.data.code === 200) {
          if (res.data.data) {
            this.vs = res.data.data
          }
        }
        this.loading = false
      })
    },
    closeDialog() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="less" scoped>
.agreement-dialog-component {
  /deep/.vk-dialog {
    color: #555;
    line-height: 18px;
    font-size: 14px;
    .dialog-content {
      padding-right: 0;
    }
    .agreement-dialog-content {
      padding-right: 20px;
      min-height: 200px;
      max-height: 400px;
      overflow-y: auto;
      overflow-x: hidden;
      /deep/.order-wapper-container {
        p {
          margin-top: 8px;
        }
        .right {
          text-align: right;
        }
        .info {
          background-color: #fffce0;
          margin-bottom: 20px;
          padding: 20px;
        }
        h4 {
          margin-top: 20px;
        }
      }
    }
    * {
      color: #555;
    }
    p {
      margin-top: 8px;
    }
  }
}
</style>
